import cn from "classnames";
import { useOpenHamburgerMenu } from "@noa/ui";

interface HamburgerMenuProps {
  onClick?: () => void;
  isActive?: boolean;
}

const lineClass = "w-5 h-0.5 bg-current block mx-auto my-1 transition-all duration-300 ease-in-out";

export function HamburgerMenu({ onClick, isActive: controlledActive }: HamburgerMenuProps) {
  const { isActive, handleClick } = useOpenHamburgerMenu(controlledActive);

  const handlePress = () => {
    handleClick();
    onClick?.();
  };

  return (
    <button onClick={handlePress} className="app-hamburger bg-transparent border-0 p-0 cursor-pointer inline-block">
      <span className={cn(lineClass, { "translate-y-1.5 rotate-45": isActive })} />
      <span className={cn(lineClass, { "opacity-0": isActive })} />
      <span className={cn(lineClass, { "-translate-y-1.5 -rotate-45": isActive })} />
    </button>
  );
}
